
import { AppBar, CircularProgress, Box, useTheme, Toolbar, TextField, Modal, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, CssBaseline, Container, Grid, Card, CardContent, Dialog, DialogActions, DialogContent, FormControl, Stack, Chip, Autocomplete, Collapse, Alert, AlertTitle, CardHeader, Pagination, useMediaQuery } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import { alpha, styled } from '@mui/material/styles';
import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//icons
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Searchicon from '@mui/icons-material/Search';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import Close from '@mui/icons-material/Close';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// Date format
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

//hooks and links
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";
import WarehouseIndex from "../../warehouse/WarehouseList";
import LabelChildRollDetails from "../labels/ChildRoll";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { tokens } from "../../../theme/theme";
import CallAlertBar from "../../../Layout/Alertbar";
import Header from "../../../Layout/Header";
import FilterButtons from "../../../components/FilterButton";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import GlobalConfig from "../../../config/date/GlobalConfig";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import CustomPagination from "../../../components/table/CustomPagination";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import TableFilterRow from "../../../components/table/TableFilterRow";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import AddRemarks from "../../master/AddRemarks";
import { set } from "date-fns";

const ReelWeightment = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const [orderFromDate, setOrderFromDate] = useState(dayjs());
    const [orderToDate, setOrderToDate] = useState(dayjs());

    const [reelWeightementMsgOpen, setReelWeightementMsgOpen] = useState(false);
    const [reelWeightementSeverityvalue, setReelWeightementSeverityvalue] = useState('info');
    const [reelWeightementMessageValue, setReelWeightementMessageValue] = useState('');
    const [reelWeightementAlertTitleValue, setReelWeightementAlertTitleValue] = useState('');

    const [sheeterChildRoll, setSheeterChildRoll] = useState([]);
    const [sheeterSelectedChildRoll, setSheeterSelectedChildRoll] = useState(null);
    const [selectedSheeterChildRollDetail, setSelectedSheeterChildRollDetail] = useState([]);
    const [open, setOpen] = useState(false);

    // fields data

    const [code, setCode] = useState('');
    const [status, setStatus] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [parentRoll, setParentRoll] = useState('');
    const [reelNo, setReelNo] = useState('');
    const [quality, setQuality] = useState('');
    const [gsm, setGSM] = useState('');
    const [reelSize, setReelSize] = useState(0);
    const [reelLength, setReelLength] = useState(0);
    const [reelWeight, setReelWeight] = useState(0);
    const [reelJoined, setReelJoined] = useState(0);
    const [id, setID] = useState(0);
    const [lotNumber, setLotNumber] = useState('');
    const [remark, setRemark] = useState('');


    const [remarkOptions, setRemarkOptions] = useState([]);
    const [loadingRemarks, setLoadingRemarks] = useState(false);
    const [openAddRemark, setOpenAddRemark] = useState(false);

    // dummy ids
    const [parentModuleId, setParentModuleId] = useState(0);
    const [moduleId, setModuleId] = useState(0);


    // Handlers for AddRemarks dialog
    const handleOpenAddRemark = () => setOpenAddRemark(true);
    //const handleCloseAddRemark = () => setOpenAddRemark(false);


    const handleCloseAddRemark = () => {
        setOpenAddRemark(false);
    };

    // Fetch remarks based on module id and parent module id
    // useEffect(() => {
    //     // ensure moduleId and parentModuleId are available
    //     setLoadingRemarks(true);
    //     const params = {
    //         p_companyid: localStorage.getItem("companyid"),
    //         module_id: moduleId,
    //         parent_module_id: parentModuleId
    //     };
    //     callApi(API_ENDPOINTS.MASTER_GET_REMARKS, "POST", { "Content-Type": "application/json" }, params)
    //         .then((data) => {
    //             if (data && Array.isArray(data)) {
    //                 setRemarkOptions(data);   // 👈 keep full objects from API
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Failed to load remarks", err);
    //             setRemarkOptions([]);
    //         })
    //         .finally(() => setLoadingRemarks(false));
    // }, [moduleId, parentModuleId, openAddRemark]);



    const [partyRemark, setPartyRemark] = useState('');
    const [locationRef, setLocationRef] = useState('');
    const [poNumber, setPONumber] = useState('');
    const [scanQRValue, setQRValue] = useState('');
    const [wlocationRef, setWLocationRef] = useState('');
    const [roolLength, setRoolLength] = useState(0);

    // State for the QR code value
    const [qrCodeValue, setQRCodeValue] = useState('Netique infotech');
    const [selectedChildRollDetails, setSelectedChildRollDetails] = useState([]);
    const [enableSaveBtn, setEnableSaveBtn] = useState(false);
    const [hideSaveBth, setHideSaveBtn] = useState(false);


    const [quantity, setQuantity] = useState('');
    const [unit, setUnit] = useState('');

    const [focusWeight, setFocusWeight] = useState(false);
    const [updateReelNumber, setUpdateReelNumber] = useState('');

    const [updateReelWeight, setUpdateReelWeight] = useState(0);
    const [reelWeightMessage, setReelWeightMessage] = useState('');
    const [viewReelDetail, setViewReelDetail] = useState(false);
    const [viewQRCodeDetails, setviewQRCodeDetails] = useState(false);

    const [completedStatus, setCompletedStatus] = useState([]);
    const [selectedButton, setSelectedButton] = useState(null);

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);

    const [period, setPeriod] = useState('Today');


    const [viewChildRollList, setViewChildRollList] = useState(true);
    const [viewReelWeightment, setViewReelWeightment] = useState(false);
    const [enableWarehouseOption, setEnableWarehouseOption] = useState(false);
    const [viewWarehouseLocation, setViewWarehouseLocation] = useState(false);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Child Roll List');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);
    const [partyList, setPartyList] = useState([]);
    const [locationDetail, setLocationDetail] = useState([]);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);
    const userPermissions = useUserPermissions();

    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [shiftCodes, setShiftCodes] = useState([]);
    const [shiftDate, setShiftDate] = useState(dayjs());

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [selectedOperatorID, setSelectedOperatorID] = useState(0);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);
    const [winderOperators, setWinderOperators] = useState('');

    const [selectedGrade, setSelectedGrade] = useState([]);

    const [loading, setLoading] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    // Responsive breakpoints
    const isXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));
    const isSm = useMediaQuery((theme) => theme.breakpoints.only("sm"));
    const isMd = useMediaQuery((theme) => theme.breakpoints.only("md"));
    const isLg = useMediaQuery((theme) => theme.breakpoints.only("lg"));
    const isXl = useMediaQuery((theme) => theme.breakpoints.only("xl"));

    // Update recordsPerPage based on screen size
    useEffect(() => {
        if (isXs) setRecordsPerPage(2);
        else if (isSm) setRecordsPerPage(5);
        else if (isMd) setRecordsPerPage(7);
        else if (isLg) setRecordsPerPage(12);
        else if (isXl) setRecordsPerPage(23);
    }, [isXs, isSm, isMd, isLg, isXl]);


    // tool tip content 
    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });


    useEffect(() => {
        setLoadingRemarks(true);

        if (userPermissions.length > 0) {
            const moduledetails = userPermissions.find(
                (m) =>
                    m.module_name === "Reel Weightment" &&
                    m.parent_module_name === "Production"
            );
            if (moduledetails) {
                const params = {
                    p_companyid: localStorage.getItem("companyid"),
                    module_id: moduledetails.module_id,
                    parent_module_id: moduledetails.parent_module_id
                };
                setParentModuleId(moduledetails.parent_module_id);
                setModuleId(moduledetails.module_id);

                callApi(API_ENDPOINTS.MASTER_GET_REMARKS, "POST", { "Content-Type": "application/json" }, params)
                    .then((data) => {
                        if (data && Array.isArray(data)) {
                            setRemarkOptions(data);
                        }
                    })
                    .catch((err) => {
                        console.error("Failed to load remarks", err);
                        setRemarkOptions([]);
                    })
                    .finally(() => setLoadingRemarks(false));
            }
        }
    }, [moduleId, parentModuleId, openAddRemark, userPermissions]);


    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Child Roll List') {
            setSelectedStatus('All');
        }
        else if (option === 'Unweighted Reels') {
            setSelectedStatus('Booked');
        }
        else if (option === 'FG Child Roll') {
            setSelectedStatus('fg');
        }
        else if (option === 'Inprogress Child Roll') {
            setSelectedStatus('wip');
        }
        else if (option === 'Cancelled Child Roll') {
            setSelectedStatus('cancelled');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const [isGrossWeight, setIsGrossWeight] = useState(false);
    const [addGrossWeight, setAddGrossWeight] = useState(0);


    // Custom styling for speed
    const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
        animationDuration: '0.5s', // Adjust the speed here (default is 1.4s)
        '& .MuiCircularProgress-circle': {
            stroke: '#4CAF50', // Ensure color is applied to the correct part of the SVG
        },
    }));

    useEffect(() => {
        if (!isGrossWeight) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_id_default_value: 1
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_DEFAULT_VALUES, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(result => {
                    if (result && result.length > 0) {

                        if (result[0].double_value > 0) {
                            setAddGrossWeight(result[0].double_value);
                            setIsGrossWeight(true);
                        }
                        else {
                            alert('Please set reel gross weight value');
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isGrossWeight]);

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const p_companyid = localStorage.getItem('companyid');
            const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
            const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');

            const para = {
                p_companyid: p_companyid,
                p_frommodate,
                p_tomodate,
                page: currentPage,
                pageSize: pageSize,
            };
            setLoading(true);
            try {
                const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REEL_WEIGHTMENT_LIST, 'POST', { 'Content-Type': 'application/json' }, para);
                if (data) setPartyList(data);
            } catch (error) {
                alert(error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [currentPage, pageSize, FromDate, ToDate, setFromDate, setToDate]);



    const LoadReelWeightmentList = async () => {

        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');

        const para = {
            p_companyid: p_companyid,
            p_frommodate,
            p_tomodate,
        }
        setLoading(true);
        await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_REEL_WEIGHTMENT_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPartyList(data);
                    setLoading(false);
                }
            })
            .catch(error => {
                alert(error.message);
                setLoading(false);
            });
    }


    const callback = () => {
        // handleBackWinderMachineEntry();
        setEditPartyID(0);
        setViewChildRollList(true);
        setViewReelWeightment(false);
        LoadReelWeightmentList();
    };

    useEffect(() => {

        filterData('All');
        const handleKeyPress = (event) => {

            if (event.ctrlKey && event.key === 'v') {
                // Perform form submission or any action you desire
                // console.log('Form submitted!');
                // alert('It is Working');
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);


    const handlePrint = (event) => {
        event.preventDefault();
        // Perform form submission logic
        console.log('Form submitted with data:');
    };


    const handleQuantityChange = (event) => {
        setQuantity(event.target.value);
    };

    const handleUnitChange = (event) => {
        setUnit(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Handle submission logic here
        console.log("Quantity:", quantity, "Unit:", unit);
        // Reset fields if needed
        setQuantity('');
        setUnit('');
    };


    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    useEffect(() => {
        if (winderShiftID && shiftCodes.length === 0) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

        if (winderShiftID && shiftCodes.length > 0) {
            const selected = shiftCodes.find(c => c.shiftid === winderShiftID);
            if (selected) {
                setWinderShiftCode(selected);

            }
        }
    }, [shiftCodes, winderShiftID]);


    const handleWinderShiftChange = (event, value) => {
        if (value !== undefined && value !== null) {
            setWinderShiftCode(value);
            setWinderShiftID(value.shiftid);
        }
    }

    // Get Operator
    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                        setSelectedOperatorID(data[0].id);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);

    //-- update operater
    useEffect(() => {
        if (selectedOperatorID && operator.length === 0) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }

        if (selectedOperatorID && operator.length > 0) {
            const selected = operator.find(c => c.id === selectedOperatorID);
            if (selected) {
                setSelectedOperator(selected);

            }
        }
    }, [operator, selectedOperatorID]);


    const handleOperatorChange = (event, value) => {
        if (value !== undefined && value !== null) {
            setSelectedOperator(value);
            setSelectedOperatorName(value.operator_code);
            setWinderOperators(value.operator_code);
            setSelectedOperatorID(value.id);
        }
    }

    const getApprovedReelsList = () => {


        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(orderToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "";
        const p_mono = 1;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };


        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_APROVED_ALL_CHILD_LIST, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setSheeterChildRoll(data);

                } else {
                    // No data found
                    // setSheeterChildRoll(null);
                    setReelWeightementSeverityvalue('info');
                    setReelWeightementMessageValue('No Child roll found this date range (' + p_frommodate + ' - ' + p_tomodate + ")");
                    setReelWeightementAlertTitleValue('info');
                    setReelWeightementMsgOpen(true);

                }
            })
            .catch(error => {
                // Update state with error message        
                setReelWeightementSeverityvalue('error');
                setReelWeightementMessageValue(error.message);
                setReelWeightementAlertTitleValue('Error');
                setReelWeightementMsgOpen(true);
            });

    };

    const handleSelectSheeterChildRollNumber = (event, value) => {

        setSheeterSelectedChildRoll(value);
        setUpdateReelNumber(value.child_reel_number);
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_child_reel_number: value.child_reel_number,
        };


        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_APROVED_CHILD_ROLL_DETAILS_SHEETER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {

                setSelectedSheeterChildRollDetail(data);

                // update detail
                setCode(value.child_reel_number);

                setParentRoll(data[0].pr_number);
                setReelNo(data[0].pr_number);
                setQuality(data[0].item_code);
                setGSM(data[0].gsm);
                setReelWeight(data[0].achieved_qty * 1000);
                setReelSize(data[0].master_reel);
                //setSheeterWidth(data[0].width);
                setReelLength(data[0].length);
                setID(data[0].pr_id);
                setLotNumber(data[0].ma_number);
                setFocusWeight(true);
                setUpdateReelWeight((data[0].achieved_qty * 1000));
                setViewReelDetail(true);

                setSelectedGrade(data[0].grade);
                setRemark(data[0].remarks || '');
                setPONumber(data[0].indent_number);
                setSelectStatus(data[0].status);
                setPartyRemark(data[0].party_remarks || '');
                setRoolLength(data[0].reel_length || '');
                let reelStatus = data[0].status;

                if (data[0].status != 'approved') {
                    setWinderShiftID(data[0].rw_id)
                    setShiftDate(data[0].rw_date);
                    setLocationRef(data[0].location_ref);
                    setSelectedOperatorID(data[0].id_operator);
                }
                else {
                    setLocationRef('');
                    setSelectedOperatorID(1);
                    setWinderShiftID(1);
                    setShiftDate(dayjs());
                }

                if (data[0].status === 'approved') {
                    setStatus('Approved')
                    setEnableSaveBtn(false);
                    //setHideSaveBtn(false);
                }
                else if (data[0].status === 'converted') {
                    setStatus('Converted')
                    setEnableSaveBtn(false);
                    setEnableWarehouseOption(true);
                    //setHideSaveBtn(true);
                }

                else if (data[0].status === 'wip') {
                    setStatus('WIP')
                    setEnableSaveBtn(true);
                    //setHideSaveBtn(false);
                }
                else if (data[0].status === 'fg') {
                    setStatus('FG');
                    setEnableSaveBtn(true);
                    //setHideSaveBtn(false);
                }

                callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                    .then(data => {
                        //setSelectedChildRollDetails(data[0]);

                        setSelectedChildRollDetails({
                            ...data[0],
                            achieved_qty: Math.round(data[0].achieved_qty * 1000 * 10) / 10,
                            gross_qty: Math.round(data[0].gross_qty * 1000 * 10) / 10
                        });

                        if (reelStatus === 'fg' || reelStatus === 'stored') {
                            setUpdateReelWeight(data[0].gross_qty * 1000);
                        }
                        const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                            `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                            `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                            `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                            `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                            `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                            `Reel Length: ${data[0].reel_length || 0} meters, ` +
                            `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;

                        setQRCodeValue(qrValue);


                        // get warehouse location for reels
                        const warehousedata = callApi(API_ENDPOINTS.WAREHOUSE_GET_CHILD_REEL_LOCATION, 'POST', { 'Content-Type': 'application/json' }, orderData);
                        if (warehousedata && warehousedata.length > 0) {
                            setLocationDetail(warehousedata);
                        }
                        else { setEnableWarehouseOption(true); }

                    })
                    .catch(error => {
                        // Update state with error message        
                        setReelWeightementSeverityvalue('error');
                        setReelWeightementMessageValue(error.message);
                        setReelWeightementAlertTitleValue('Error');
                        setReelWeightementMsgOpen(true);
                    });

            })
            .catch(error => {
                // Update state with error message        
                setReelWeightementSeverityvalue('error');
                setReelWeightementMessageValue(error.message);
                setReelWeightementAlertTitleValue('Error');
                setReelWeightementMsgOpen(true);
            });

    }

    const [selectedFromDate, setSelectedFromDate] = useState(dayjs());
    const [selectedToDate, setSelectedToDate] = useState(dayjs());

    const filterData = (filter) => {
        let fromDate, toDate;

        setReelWeightementMsgOpen(false);
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }
        setSelectedFromDate(fromDate);
        setSelectedToDate(toDate);

    };


    useEffect(() => {

        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = selectedFromDate;//dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = selectedToDate;//dayjs(orderToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "";
        const p_mono = 1;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };
        setViewReelDetail(false);

        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_APROVED_ALL_CHILD_LIST, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setSheeterChildRoll(data);
                    setSheeterSelectedChildRoll(null);

                } else {
                    // No data found
                    setSheeterChildRoll(null);
                    setReelWeightementSeverityvalue('info');
                    setReelWeightementMessageValue('No Child roll found this date range (' + p_frommodate + ' - ' + p_tomodate + ")");
                    setReelWeightementAlertTitleValue('info');
                    setReelWeightementMsgOpen(true);
                    setSheeterSelectedChildRoll(null);

                }
            })
            .catch(error => {
                // Update state with error message        
                setReelWeightementSeverityvalue('error');
                setReelWeightementMessageValue(error.message);
                setReelWeightementAlertTitleValue('Error');
                setReelWeightementMsgOpen(true);
            });


        setSheeterSelectedChildRoll(null);

    }, [selectedFromDate, selectedToDate]);



    const updateReelWeightValue = (e) => {

        let reelweightmaximumlimit = reelWeight + (reelWeight * 10 / 100);
        if (reelweightmaximumlimit >= e.target.value) {
            setUpdateReelWeight(e.target.value);
            setReelWeightMessage('');
        }
        else {
            setUpdateReelWeight(reelWeight);
            setReelWeightMessage('Can not be allowed greater then 10% reel weight as MO Quantity.');
        }

    };

    const SaveReelWeightement = () => {

        if (!hasPermission(userPermissions, "Reel Weightment", "Create")) {
            alert("Access denied. You don’t have permission to save the reel weight.");
            return; // Exit the function if permission is not granted
        }

        setReelWeightementMsgOpen(false);
        //(parseInt(updateReelWeight) + addGrossWeight)
        let sumofgrossweight = updateReelWeight;
        let netweight = (updateReelWeight) - addGrossWeight;
        let isvalid = true;

        if (locationRef === null) {
            isvalid = false;
            setReelWeightementSeverityvalue('warning');
            setReelWeightementMessageValue('Kindly set location for reel fg');
            setReelWeightementAlertTitleValue('Validation');
            setReelWeightementMsgOpen(true);
        }

        if (reelLength === 0 && locationRef === '') {
            isvalid = false;
            setReelWeightementSeverityvalue('warning');
            setReelWeightementMessageValue('Kindly set location for reel fg');
            setReelWeightementAlertTitleValue('Validation');
            setReelWeightementMsgOpen(true);
        }

        if (isvalid) {
            if (updateReelWeight > 0) {
                const parameter = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_plantid: 1,
                    p_child_reel_number: updateReelNumber,
                    p_reel_weight: (netweight / 1000),//(updateReelWeight / 1000)
                    p_reel_gross_weight: (sumofgrossweight / 1000),
                    p_shift_id: winderShiftID,
                    p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_operator_id: selectedOperatorID,
                    p_grade: selectedGrade,
                    p_remarks: remark,
                    p_location: locationRef,
                    p_status: selectStatus,
                    p_party_remarks: partyRemark,
                };


                callApi(API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_REEL_WEIGHT, 'POST', { 'Content-Type': 'application/json' }, parameter)
                    .then(data => {
                        if (data && data.length > 0) {
                            setCompletedStatus(data);
                            setReelWeight(updateReelWeight);

                            if (data[0].status === 'approved') {
                                setStatus('Approved')
                                setEnableSaveBtn(false);
                                setEnableWarehouseOption(false);
                            }
                            else if (data[0].status === 'wip') {
                                setStatus('WIP')
                                setEnableSaveBtn(true);
                                setEnableWarehouseOption(false);
                            }
                            else if (data[0].status === 'fg' || data[0].status === 'stored') {
                                setStatus('FG')
                                setEnableSaveBtn(true);
                                setEnableWarehouseOption(true);
                            }

                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Reel weight update successfully!', { position: toast.POSITION.BOTTOM_CENTER });

                            const orderData = {
                                p_companyid: localStorage.getItem('companyid'),
                                p_child_reel_number: updateReelNumber,
                            };

                            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                                .then(data => {

                                    setSelectedChildRollDetails({
                                        ...data[0],
                                        achieved_qty: Math.round(data[0].achieved_qty * 1000 * 10) / 10,
                                        gross_qty: Math.round(data[0].gross_qty * 1000 * 10) / 10
                                    });

                                    const formattedDate = dayjs(data[0].shift_date).format('DD-MM-YYYY');
                                    // Set the formatted date to the state
                                    // setSelectedChildRollDetails({
                                    //     ...data[0],
                                    //     shift_date: formattedDate,
                                    // });
                                    const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                                        `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                                        `Size: ${data[0].width || '0'} X ${data[0].length}, ` +

                                        `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                                        `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                                        `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                                        `Reel Length: ${data[0].reel_length || 0} meters, ` +
                                        `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;
                                    setQRCodeValue(qrValue);

                                })
                                .catch(error => { msg('error', error.message, 'Error') });
                        }
                    })
                    .catch(error => {
                        // Update state with error message        
                        setReelWeightementSeverityvalue('error');
                        setReelWeightementMessageValue(error.message);
                        setReelWeightementAlertTitleValue('Error');
                        setReelWeightementMsgOpen(true);
                    });

            }
            else {
                setReelWeightementSeverityvalue('warning');
                setReelWeightementMessageValue('Please enter MA reel weight.');
                setReelWeightementAlertTitleValue('Warning');
                setReelWeightementMsgOpen(true);
            }
        }

    };

    //reverse-update-reel_weightment

    const handleReverseReelWeightment = () => {

        setReelWeightementMsgOpen(false);

        let sumofgrossweight = (parseInt(updateReelWeight) + addGrossWeight)
        let isvalid = true;

        if (locationRef === null) {
            isvalid = false;
            setReelWeightementSeverityvalue('warning');
            setReelWeightementMessageValue('Kindly set location for reel fg');
            setReelWeightementAlertTitleValue('Validation');
            setReelWeightementMsgOpen(true);
        }

        if (reelLength === 0 && locationRef === '') {
            isvalid = false;
            setReelWeightementSeverityvalue('warning');
            setReelWeightementMessageValue('Kindly set location for reel fg');
            setReelWeightementAlertTitleValue('Validation');
            setReelWeightementMsgOpen(true);
        }

        if (isvalid) {
            if (updateReelWeight > 0) {
                const parameter = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_plantid: 1,
                    p_child_reel_number: updateReelNumber,
                    p_reel_weight: (updateReelWeight / 1000),
                    p_reel_gross_weight: (sumofgrossweight / 1000),
                    p_shift_id: winderShiftID,
                    p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_operator_id: selectedOperatorID,
                    p_grade: selectedGrade,
                    p_remarks: remark,
                    p_location: locationRef,
                    p_status: selectStatus,
                    p_party_remarks: partyRemark,
                };


                callApi(API_ENDPOINTS.PROD_MANAGEMENT_REVERSE_UPDATE_REEL_WEIGHT, 'POST', { 'Content-Type': 'application/json' }, parameter)
                    .then(data => {
                        if (data && data.length > 0) {
                            setCompletedStatus(data);
                            setReelWeight(updateReelWeight);

                            if (data[0].status === 'approved') {
                                setStatus('Approved')
                                setEnableSaveBtn(false);
                                setEnableWarehouseOption(false);
                            }
                            else if (data[0].status === 'wip') {
                                setStatus('WIP')
                                setEnableSaveBtn(true);
                                setEnableWarehouseOption(false);
                            }
                            else if (data[0].status === 'fg' || data[0].status === 'stored') {
                                setStatus('FG')
                                setEnableSaveBtn(true);
                                setEnableWarehouseOption(true);
                            }
                            else if (data[0].status === 'booked') {
                                setStatus('booked')
                                setEnableSaveBtn(true);
                                setEnableWarehouseOption(false);
                            }

                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Reel weight update reversed successfully!', { position: toast.POSITION.BOTTOM_CENTER });

                            const orderData = {
                                p_companyid: localStorage.getItem('companyid'),
                                p_child_reel_number: updateReelNumber,
                            };

                            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                                .then(data => {
                                    //setSelectedChildRollDetails(data[0]);

                                    setSelectedChildRollDetails({
                                        ...data[0],
                                        achieved_qty: Math.round(data[0].achieved_qty * 1000 * 10) / 10,
                                        gross_qty: Math.round(data[0].gross_qty * 1000 * 10) / 10
                                    });

                                    const formattedDate = dayjs(data[0].shift_date).format('DD-MM-YYYY');
                                    // Set the formatted date to the state
                                    // setSelectedChildRollDetails({
                                    //     ...data[0],
                                    //     shift_date: formattedDate,
                                    // });
                                    const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                                        `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                                        `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                                        `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                                        `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                                        `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                                        `Reel Length: ${data[0].reel_length || 0} meters, ` +
                                        `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;
                                    setQRCodeValue(qrValue);

                                })
                                .catch(error => { msg('error', error.message, 'Error') });
                        }
                    })
                    .catch(error => {
                        // Update state with error message        
                        setReelWeightementSeverityvalue('error');
                        setReelWeightementMessageValue(error.message);
                        setReelWeightementAlertTitleValue('Error');
                        setReelWeightementMsgOpen(true);
                    });

            }
            else {
                setReelWeightementSeverityvalue('warning');
                setReelWeightementMessageValue('Please enter MA reel weight.');
                setReelWeightementAlertTitleValue('Warning');
                setReelWeightementMsgOpen(true);
            }
        }
    }


    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/ITC_logo.png',

    });

    function formatDate(dateString) {
        if (!dateString) return ''; // Handle null or undefined date
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
        const year = date.getFullYear(); // Get full year
        return `${day}/${month}/${year}`;
    }


    const handleButtonClick = async (buttonName) => {
        setSelectedButton(buttonName);
        setReelWeightementMsgOpen(false);

        let bundleDetails = selectedChildRollDetails;
        bundleDetails = bundleDetails ? [bundleDetails] : []; // Wrap bundleDetails in an array if it exists
        let isvalid = true;

        if (bundleDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!bundleDetails || bundleDetails.length === 0)) {
            isvalid = false;

            setReelWeightementSeverityvalue('info');
            setReelWeightementMessageValue('Please select reel code to print. ');
            setReelWeightementAlertTitleValue('info');
            setReelWeightementMsgOpen(true);
        }

        let mode = 0;

        if (isvalid == true) {
            if (buttonName === "PrintQR") {
                bundleDetails = selectedChildRollDetails;
                bundleDetails = bundleDetails ? [bundleDetails] : []; // Wrap bundleDetails in an array if it exists
            }

            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code
                for (const qrCodeValue of bundleDetails) {
                    // Generate QR code data URL
                    const qrDataUrl = await generateQRCode(qrCodeValue.child_reel_number);
                    // Check if QR code generation was successful
                    if (!qrDataUrl) {
                        console.error('Error generating QR code for value:', qrCodeValue.child_reel_number);
                        continue; // Skip to the next QR code
                    }

                    //     // Write HTML content for the QR code to the print window
                    //     printWindow.document.write(`

                    // <html>
                    //     <head>
                    //         <title>Printed Report</title>
                    //         <style>
                    //         body {
                    //             margin: 0;
                    //             padding: 0;
                    //             font-family: Arial, sans-serif;
                    //         }
                    //         .container {
                    //             display: flex;
                    //             align-items: center;
                    //             justify-content: space-between;
                    //             padding: 10px;
                    //             border: 1px solid #ccc;
                    //             box-sizing: border-box;
                    //         }
                    //         .qr-code {
                    //             width: 150px; /* Adjust as needed */
                    //         }
                    //         .bundle-details {
                    //             flex: 1;
                    //             margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                    //         }
                    //         .bundle-details h5 {
                    //             margin: 0;
                    //             font-size: 18px;
                    //         }
                    //         .bundle-details h6 {
                    //             margin: 5px 0;
                    //             font-size: 16px;
                    //         }
                    //     </style>
                    //     </head>
                    //     <body>
                    //     <div class="container">
                    //     <div>
                    //         <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                    //         <h3>${qrCodeValue.child_reel_number || 'XXXXXX0123'}</h3>
                    //     </div>
                    //     <div class="bundle-details">
                    //         <div>
                    //             <h5>Child Roll Details</h5>
                    //         </div>
                    //         <h6>Child Roll No : ${selectedChildRollDetails.child_reel_number || 'XXXXXX0123'}</h6>
                    //         <h6>Quality : ${selectedChildRollDetails.item_code || 'XXXXQuality'}</h6>
                    //         <h6>Size : ${selectedChildRollDetails.width || '0'} X ${selectedChildRollDetails.length || '0'}</h6>
                    //         <h6>GSM : ${gsm}, BF: ${selectedChildRollDetails.bf || 0}</h6>
                    //         <h6>ID/OD :${selectedChildRollDetails.core_id || 0} /${selectedChildRollDetails.reel_od || 0}</h6>
                    //         <h6>Roll.wt: ${reelWeight || 0}(Mt) , Reel Length:${selectedChildRollDetails.reel_length || 0} meters.</h6>
                    //     </div>



                    // </div>
                    //     </body>
                    // </html>


                    // `);

                    // Write HTML content for the QR code to the print window
                    printWindow.document.write(`
                        <html>
                            <head>
                                <title>Printed Report</title>
                                <style>
                                    @page {
                                            size: 100mm 150mm; /* Portrait orientation */
                                            margin: 0; /* Remove margins for edge-to-edge printing */
                                    }
                                    body {
                                            margin-left: 1mm;
                                            padding: 0;
                                            font-family: Arial, sans-serif;
                                            display: flex;
                                            flex-direction: column;
                                            align-items: flex-start;
                                            justify-content: flex-start;
                                            box-sizing: border-box;
                                    }
                                    .labelx {
                                            width: 100mm;
                                            height: 150mm;
                                            /*padding: 3mm;*/
                                            box-sizing: border-box;
                                            /*border: 1px solid #000;*/
                                            display: flex;
                                            flex-direction: column;
                                            justify-content: space-between;
                                        
                                    }
                                    
                                
                                    .container {
                                        width: 100%;
                                        height: 100%;                                
                                        box-sizing: border-box;
                                    }
                                    .header {
                                        display: flex;
                                        align-items: center;                                    
                                    }
                                    .header img {
                                        width: 20mm;
                                        height: auto;
                                        margin-right: 10mm;
                                    }
                                    .company-details h4 {
                                        font-weight: bold;
                                        color: #01579b;
                                        margin: 0;
                                        font-size: 12px;
                                    }
                                    .marketed-by {
                                        text-align: center; /* Aligns all text in this div to the center */
                                    }
                                    .divider {
                                        width: 100%; /* Full width of the container */
                                        height: 1px; /* Thin line for the divider */
                                        background-color: #000; /* Black color for visibility */
                                        margin: 10px 0; /* Spacing above and below */
                                    }
                                    .details-table {
                                        width: 100%;
                                        border-collapse: collapse;
                                        
                                        font-size: 15px;
                                    }
                                    .details-table th, .details-table td {
                                        padding: 2mm;
                                        text-align: left;
                                        border: 1px solid #ccc;
    
                                        font-weight: bold;
                                    }
                                    .details-table th {
                                        background-color: #f2f2f2;
                                        font-weight: bold;
                                    }
                                    .qr-code-container {
                                        text-align: center;
                                        margin-top: 5mm;
                                    }
                                    .qr-code-container img {
                                        width: 30mm;
                                        height: auto;
                                    }
                                    .qr-code-container h3 {
                                        font-weight: bold;
                                        font-size: 12px;
                                        margin: 5mm 0 0 0;
                                    }
                                    .footer {
                                        text-align: center;
                                        margin-top: 5mm;
                                        font-size: 14px;
                                        font-weight: bold;
                                    
                                    }
                                    .title {
                                        text-align: center;
                                         margin-top: 40mm;
                                        font-size: 10px;
                                        font-weight: bold;
                                    
                                    }    
                                        
                                </style>
                            </head>
                            <body>
                                <div class="labelx">
                                    <div class="container">                                
                                        <!-- Header -->
                                        <div class="title">
                                            
                                        </div> 
    
                                        <!-- Product Details Table -->
                                        <table class="details-table">
                                            <tr>
                                                <th>PRODUCT</th>
                                                <td>${selectedChildRollDetails.item_code}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold;" >GSM</th>
                                                <td>${selectedChildRollDetails.gsm}</td>
                                            </tr>
                                             <tr>
                                                <th style="font-weight: bold;">SIZE (CM)</th>
                                                <td>
                                                    ${selectedChildRollDetails.length === 0
                            ? selectedChildRollDetails.width || '0'
                            : `${selectedChildRollDetails.width || '0'} X ${selectedChildRollDetails.length || '0'}`}
                                                </td>
                                            </tr>                                        
                                            <tr>
                                                <th>REEL DIA (CM)</th>
                                                <td>${selectedChildRollDetails.reel_od}</td>
                                            </tr>
                                            <tr>
                                                <th>CORE DIA (inch)</th>
                                                <td>${selectedChildRollDetails.core_id}</td>
                                            </tr>
                                            <tr>
                                                <th>REEL NO.</th>
                                                <td>${selectedChildRollDetails.child_reel_number}</td>
                                            </tr>
                                            <tr>
                                                <th>NET WEIGHT (KG)</th>
                                                <td>${(selectedChildRollDetails.achieved_qty)}</td>
                                            </tr>
    
                                            <!-- Conditionally Add GROSS WEIGHT Row -->
                                            ${mode === 0 ? `
                                                <tr>
                                                    <th>GROSS WEIGHT (KG)</th>
                                                    <td>${(selectedChildRollDetails.gross_qty)}</td>
                                                </tr>
                                            ` : ''}
                                            <tr>
                                                <th>REMARKS</th>
                                                <td style="font-size: 8px;">${(selectedChildRollDetails.party_remarks || '')}</td>
                                            </tr>
    
                                            <tr>
                                                <th style="font-weight: bold;">DATE</th>
                                                <td>${formatDate(selectedChildRollDetails.rw_shift_date)}</td>
                                            </tr>
                                        </table>            
                                    
    
                                        <!-- Footer Section -->
                                        ${mode === 0 ? `
                                        <div class="footer">
                                            <h2>MADE IN INDIA</h2>
                                        </div>    
                                        ` : ''}            
                                    </div>
                                </div>
                                  <div class="labelx">
                                    <div class="container">                                
                                        <!-- Header -->
                                        <div class="title">
                                            <h2>REEL CARD</h2>
                                        </div> 
    
                                        <!-- Product Details Table -->
                                        <table class="details-table">
                                            <tr>
                                                <th>PRODUCT</th>
                                                <td>${selectedChildRollDetails.item_code}</td>
                                            </tr>
                                            <tr>
                                                <th style="font-weight: bold;" >GSM</th>
                                                <td>${selectedChildRollDetails.gsm}</td>
                                            </tr>
                                             <tr>
                                                <th style="font-weight: bold;">SIZE (CM)</th>
                                                <td>
                                                    ${selectedChildRollDetails.length === 0
                            ? selectedChildRollDetails.width || '0'
                            : `${selectedChildRollDetails.width || '0'} X ${selectedChildRollDetails.length || '0'}`}
                                                </td>
                                            </tr>                                        
                                            <tr>
                                                <th>REEL DIA (CM)</th>
                                                <td>${selectedChildRollDetails.reel_od}</td>
                                            </tr>
                                            <tr>
                                                <th>CORE DIA (inch)</th>
                                                <td>${selectedChildRollDetails.core_id}</td>
                                            </tr>
                                            <tr>
                                                <th>REEL NO.</th>
                                                <td>${selectedChildRollDetails.child_reel_number}</td>
                                            </tr>
                                            <tr>
                                                <th>NET WEIGHT (KG)</th>
                                                <td>${(selectedChildRollDetails.achieved_qty)}</td>
                                            </tr>
    
                                            <!-- Conditionally Add GROSS WEIGHT Row -->
                                            ${mode === 0 ? `
                                                <tr>
                                                    <th>GROSS WEIGHT (KG)</th>
                                                    <td>${(selectedChildRollDetails.gross_qty)}</td>
                                                </tr>
                                            ` : ''}
                                            <tr>
                                                <th>REMARKS</th>
                                                <td style="font-size: 8px;">${(selectedChildRollDetails.party_remarks || '')}</td>
                                            </tr>
    
                                            <tr>
                                                <th style="font-weight: bold;">DATE</th>
                                                <td>${formatDate(selectedChildRollDetails.rw_shift_date)}</td>
                                            </tr>
                                        </table>            
                                    
    
                                        <!-- Footer Section -->
                                        ${mode === 0 ? `
                                        <div class="footer">
                                            <h2>MADE IN INDIA</h2>
                                        </div>    
                                        ` : ''}            
                                    </div>
                                </div>
                                
                            </body>
                        </html>
                    `);


                }
                // Close the print window and print the report
                printWindow.document.close();
                printWindow.print();

            } catch (error) {
                console.error('Error handling button click:', error);
            }

        }


    };

    //     <!-- Header Section -->
    //     <div class="header">
    //         <img src="${headerData.logo}" alt="Logo" />
    //          <div>
    //             <h4 style="margin: 0; color: #01579b;">PAPERBOARDS</h4>
    //             <h4 style="margin: 0; color: #01579b;">AND</h4>
    //             <h4 style="margin: 0; color: #01579b;">SPECIALTY</h4>
    //             <h4 style="margin: 0; color: #01579b;">PAPERS DIVISION</h4>
    //          </div>
    //     </div>

    //     <div class="divider" style="width: 100%; height: 1px; background-color: #000; margin: 5px 0;"></div>

    //     <!-- Marketed By Information -->
    //    <div class="marketed-by" style="text-align: center;">
    //     <h6 style="margin: 0;">Marketed By:</h6>
    //     <h6 style="margin: 0;">ITC Limited</h6>
    //     <h6 style="margin: 0;">106, SP Road, Secunderabad</h6>
    //     <h6 style="margin: 0;">Telangana - 500003</h5>
    //     <h6 style="margin: 0;">Phone: 91-40-27846566-73</h6>
    //    </div>


    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    const [getRejectResult, setGetRejectResult] = useState([]);

    const openpopup = async (buttonName) => {
        setSelectedButton(buttonName);
        setOpen(true);
    }

    const setWarehouse = (buttonName) => {
        setSelectedButton(buttonName);
        if (enableSaveBtn) {
            setViewReelDetail(false);
            setViewWarehouseLocation(true);
        }
        else {
            msg("info", "Kindly confirm reel weight before store in warehouse.", "Info");
        }
    }

    const closepopup = () => {
        setOpen(false);
        let reject_product_type = "ChildRoll";
        let child_roll_number = sheeterSelectedChildRoll.child_reel_number;
        let product_code = sheeterSelectedChildRoll.child_reel_number;
        let isvalid = true;

        if (enableReject == false) {
            isvalid = false;
        }
        else if (product_code === "") {
            isvalid = false;
        }
        else if (sheeterSelectedChildRoll.child_reel_number == "") {
            isvalid = false;
        }


        if (isvalid) {
            // call reject reel process
            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_reject_product_type: reject_product_type,
                p_product_code: product_code,
                p_rejectReasonID: rejectReasonID,
                p_rejectRemarks: rejectRemarks,
                p_user: localStorage.getItem('userID'),
            };

            callApi(API_ENDPOINTS.DECKL_UPDATE_REJECT_REEL, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                    }
                })
                .catch(error => { });
        }
    }

    const [filters, setFilters] = useState({
        cr_number: '',
        master_reel: '',
        release_no: '',
        item_code: '',
        gsm: '',
        from_date: '',
        to_date: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const applyFilter = () => {

        const convertInputDate = (dateString) => {
            const [year, month, day] = dateString.split('-');
            return `${month}/${day}/${year}`;
        };

        const convertDataDate = (dateString) => {
            const [day, month, year] = dateString.split('/');
            return `${month}/${day}/${year}`;
        };

        const fromDate = new Date(convertInputDate(filters.from_date));
        const toDate = new Date(convertInputDate(filters.to_date));

        const filteredData = partyList.filter(item => {
            const itemDate = new Date(convertDataDate(item.date));
            return itemDate >= fromDate && itemDate <= toDate;
        });

    };



    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = partyList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('All');




    // Helper functions for date conversion
    const convertInputDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };

    const convertDataDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${month}/${day}/${year}`;
    };


    const filteredData = useMemo(() => {
        return partyList.filter((row) => {
            if (selectedStatus !== 'All' && row.status !== selectedStatus) return false;
            return Object.keys(filters).every((key) => {
                if (!filters[key]) return true;
                // Apply your filter logic here
                if (key === 'from_date' || key === 'to_date') {
                    // Convert row date to Date object
                    const rowDate = new Date(convertDataDate(row.date));
                    const fromDate = filters.from_date ? new Date(convertInputDate(filters.from_date)) : null;
                    const toDate = filters.to_date ? new Date(convertInputDate(filters.to_date)) : null;

                    // Check if row date is within the range
                    if (fromDate && toDate) {
                        return rowDate >= fromDate && rowDate <= toDate;
                    } else if (fromDate) {
                        return rowDate >= fromDate;
                    } else if (toDate) {
                        return rowDate <= toDate;
                    }
                    return true;
                }

                // Default string comparison for other filters
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        });
    }, [partyList, filters, selectedStatus]);


    const [editPartyID, setEditPartyID] = useState(0)

    const handleCallEdit = async (value, cr_number) => {
        if (!hasPermission(userPermissions, "Reel Weightment", "View")) {
            console.warn("User does not have permission to perform this action.");
            return; // Exit the function if permission is not granted
        }

        setEditPartyID(value);
        setViewChildRollList(false);
        setViewReelWeightment(true);
        setUpdateReelNumber(cr_number);

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_child_reel_number: cr_number,
        };


        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_APROVED_CHILD_ROLL_DETAILS_SHEETER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {

                setSelectedSheeterChildRollDetail(data);

                // update detail
                setCode(cr_number);
                setParentRoll(data[0].pr_number);
                setReelNo(data[0].pr_number);
                setQuality(data[0].item_code);
                setGSM(data[0].gsm);

                setReelWeight(Math.round(data[0].achieved_qty * 1000 * 10) / 10);
                setReelSize(data[0].master_reel);
                setReelLength(data[0].length);
                setID(data[0].pr_id);
                setLotNumber(data[0].ma_number);
                setFocusWeight(true);
                setUpdateReelWeight(data[0].achieved_qty * 1000);
                setViewReelDetail(true);

                setSelectedGrade(data[0].grade);
                setRemark(data[0].remarks || '');
                setPONumber(data[0].indent_number);
                setSelectStatus(data[0].status);
                setWLocationRef(data[0].wlocation_ref);
                setPartyRemark(data[0].party_remarks || '');
                setRoolLength(data[0].reel_length || '');
                let reelStatus = data[0].status;

                if (data[0].status != 'approved') {
                    setWinderShiftID(data[0].rw_id)
                    if (data[0].rw_date === "0001-01-01T00:00:00") {
                        setShiftDate(dayjs());
                    }
                    else {
                        setShiftDate(data[0].rw_date);
                    }


                    setLocationRef(data[0].location_ref);
                    setSelectedOperatorID(data[0].id_operator);
                }

                else {
                    setLocationRef('');
                    setSelectedOperatorID(1);
                    setWinderShiftID(1);
                    setShiftDate(dayjs());
                }

                if (data[0].status === 'approved') {
                    setStatus('Approved')
                    setEnableSaveBtn(false);
                    setEnableWarehouseOption(false);
                    // setHideSaveBtn(false);
                }
                else if (data[0].status === 'converted') {
                    setStatus('Converted')
                    setEnableSaveBtn(false);
                    setEnableWarehouseOption(true);

                }

                else if (data[0].status === 'wip') {
                    setStatus('WIP')
                    setEnableSaveBtn(true);
                    setEnableWarehouseOption(false);

                }
                else if (data[0].status === 'fg' || data[0].status === 'stored') {
                    setStatus('FG')
                    setEnableSaveBtn(true);
                    setEnableWarehouseOption(true);

                }
                else {
                    setStatus('Booked')
                    setEnableSaveBtn(false);
                    setEnableWarehouseOption(false);

                }

                callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_APPROVED_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, orderData)
                    .then(data => {

                        setSelectedChildRollDetails({
                            ...data[0],
                            achieved_qty: Math.round(data[0].achieved_qty * 1000 * 10) / 10,
                            gross_qty: Math.round(data[0].gross_qty * 1000 * 10) / 10
                        });


                        if (reelStatus === 'fg' || reelStatus === 'stored') {
                            setUpdateReelWeight(Math.round(data[0].gross_qty * 1000 * 10) / 10);
                        }
                        else if (data[0].status === 'wip' || data[0].length > 0) {
                            setUpdateReelWeight(Math.round(data[0].gross_qty * 1000 * 10) / 10);

                        }

                        const formattedDate = dayjs(data[0].shift_date).format('DD-MM-YYYY');

                        // Set the formatted date to the state
                        // setSelectedChildRollDetails({
                        //     ...data[0],
                        //     shift_date: formattedDate,
                        // });

                        const qrValue = `Child Roll No: ${data[0].child_reel_number || 'XXXXXX0123'}, ` +
                            `Quality: ${data[0].item_code || 'XXXXQuality'}, ` +
                            `Size: ${data[0].width || '0'} X ${data[0].length}, ` +
                            `GSM: ${data[0].gsm}, BF: ${data[0].bf || 0}, ` +
                            `ID/OD: ${data[0].core_id || 0} / ${data[0].reel_od || 0}, ` +
                            `Roll.wt: ${data[0].achieved_qty || 0}(Mt), ` +
                            `Reel Length: ${data[0].reel_length || 0} meters, ` +
                            `Customer Number: ${data[0].customer_code || 'XXXXXXX'}`;

                        setQRCodeValue(qrValue);



                        // get warehouse location for reels
                        callApi(API_ENDPOINTS.WAREHOUSE_GET_CHILD_REEL_LOCATION, 'POST', { 'Content-Type': 'application/json' }, orderData)
                            .then(warehousedata => {
                                if (warehousedata?.length > 0) { setLocationDetail(warehousedata); setEnableWarehouseOption(false); }
                            })
                            .catch(error => { msg('error', error.message, 'Error') });

                    })
                    .catch(error => { msg('error', error.message, 'Error') });

            })
            .catch(error => { msg('error', error.message, 'Error') });
    };

    const msg = (serverity, msgvalue, title) => {
        setReelWeightementSeverityvalue(serverity);
        setReelWeightementMessageValue(msgvalue);
        setReelWeightementAlertTitleValue(title);
        setReelWeightementMsgOpen(true);
    }

    const handleShowNewVendor = () => {
        setEditPartyID(0);
        setViewChildRollList(false);
        setViewReelWeightment(true);
        RefreshData();
    }

    const RefreshData = () => {
        setPeriod('Today');
        setCode('');
        setStatus('');
        setParentRoll('');
        setReelNo('');
        setQuality('');
        setGSM('');
        setReelSize(0);
        setReelLength(0);
        setReelWeight(0);
        setReelJoined(0);
        setID(0);
        setLotNumber('');
        setRemark('');
        setLocationRef('');
        setPONumber('');
        setSelectedGrade('');
        setShiftDate(dayjs());
        setUpdateReelWeight(0);
        setViewReelDetail(false);
        setSheeterSelectedChildRoll(null);
        setWLocationRef('NA');


    }

    const callBackFromWarehouse = () => {
        setViewReelDetail(true);
        setViewWarehouseLocation(false);
        handleCallEdit(editPartyID, updateReelNumber);
    }


    // sorting process
    const [sortDirection, setSortDirection] = useState('desc');
    const [sortColumn, setSortColumn] = useState('date'); // Default sort by 'date'



    const sortedData = useMemo(() => {
        return [...filteredData].sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }, [filteredData, sortColumn, sortDirection]);

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    }

    // Calculate the number of pages
    const pageCount = Math.ceil(partyList.length / recordsPerPage);

    // Get the records for the current page
    const currentRecords = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    // filter oprations 
    const columns = ['date', 'cr_number', 'master_reel', 'width', 'release_no', 'set_no', 'item_code', 'gsm', 'order_qty', 'achieved_qty', 'status'];
    const autoCompleteColumns = ['date', 'cr_number', 'master_reel', 'width', 'release_no', 'set_no', 'item_code', 'gsm', 'status'];

    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        date: [...new Set(partyList.map(row => row.date))],
        cr_number: [...new Set(partyList.map(row => row.cr_number))],
        master_reel: [...new Set(partyList.map(row => row.master_reel))],
        width: [...new Set(partyList.map(row => row.width))],
        release_no: [...new Set(partyList.map(row => row.release_no))],
        set_no: [...new Set(partyList.map(row => row.set_no))],
        item_code: [...new Set(partyList.map(row => row.item_code))],
        gsm: [...new Set(partyList.map(row => row.gsm))],
        status: [...new Set(partyList.map(row => row.status))],

    };

    return (
        <>
            {viewWarehouseLocation && (
                <>
                    < WarehouseIndex handleBackWinderMachineEntry={callBackFromWarehouse} reelID={editPartyID} />
                </>
            )}
            <Box>

                {viewChildRollList && (
                    <>
                        <Divider />

                        <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                            <Toolbar>
                                {/* First Menu */}
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Child Roll List')}>All Child Roll Weightment</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('FG Child Roll')}>Finished Child Roll</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Unweighted Reels')}>UnWeighted Child Roll</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Inprogress Child Roll')}>Inprogress Child Roll</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled Child Roll')}>Cancelled Child Roll</MenuItem>
                                </Menu>

                                {/* Adding margin-left: auto to push the button to the right */}

                                {hasPermission(userPermissions, "Reel Weightment", "Create") && (
                                    <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                                )}

                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    aria-label="menu"
                                    sx={{ ml: 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>

                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Child rolls" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Child rolls" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                        <ListItemIcon>
                                            <ViewColumnIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Current View" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                                    </IconButton>
                                </div>
                            </Toolbar>
                        </AppBar>



                        <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                            {/* <Grid item xs={12} sm={12} md={1} lg={4} xl={2.8} mt="5px" display="flex-start" justifyContent="center">
                                       <Button>
                                        View MA Wise Balance Plan Qty
                                        </Button>
                                    </Grid> */}


                            <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                                <FormControl fullWidth size="small">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            style={{ marginLeft: '10px' }}
                                            id="FromDate"
                                            value={dayjs(FromDate)}
                                            onChange={(date) => handleDateChange2(date)}

                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    variant: 'standard', // Removes the filled/outlined border
                                                    InputProps: {
                                                        disableUnderline: true, // Remove underline from 'standard' variant
                                                    },
                                                    sx: {
                                                        backgroundColor: 'transparent',
                                                        padding: 0,
                                                        '& .MuiInputBase-root': {
                                                            border: 'none',
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: '18px', // 👈 smaller icon size
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            paddingRight: '6px', // optional: reduce padding around icon
                                                        },
                                                    },
                                                }
                                            }}
                                            renderInput={(props) => <TextField {...props} />}
                                            autoFocus
                                            format="DD-MMM-YYYY"
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item mt="5px" ml="10px" mr="10px">
                                <Typography fontWeight="bold">-</Typography>
                            </Grid>


                            <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                                <FormControl fullWidth size="small" >
                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                        <DatePicker
                                            id="ToDate"
                                            value={dayjs(ToDate)}
                                            format="DD-MMM-YYYY"
                                            onChange={(date) => handleDateChange1(date)}
                                            // slotProps={{ textField: { size: 'small', } }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    variant: 'standard', // Removes the filled/outlined border
                                                    InputProps: {
                                                        disableUnderline: true, // Remove underline from 'standard' variant
                                                    },
                                                    sx: {
                                                        backgroundColor: 'transparent',
                                                        padding: 0,
                                                        '& .MuiInputBase-root': {
                                                            border: 'none',
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: '18px', // 👈 smaller icon size
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            paddingRight: '6px', // optional: reduce padding around icon
                                                        },
                                                    },
                                                }
                                            }}
                                            renderInput={(props) => <TextField {...props} />}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>


                        </Grid>

                        <Divider sx={{ marginTop: "5px" }} />

                        <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                            <Grid item xs={12} sm={11} md={11.8} lg={11.8} xl={11.8}>

                                <ResponsiveBox colors={colors} customMaxHeight={{
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '82vh', // Large devices (desktops)
                                    xl: '86vh', // Extra large devices (large desktops)
                                }}>

                                    <CustomTableContainer colors={colors}>
                                        <TableContainer >
                                            {loading ? (
                                                <SkeletonTableLoader rows={5} columns={11} />
                                            ) : (
                                                <Table size="small">
                                                    <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                        <TableRow>

                                                            <TableCell onClick={() => handleSort('date')}>
                                                                DATE {sortColumn === 'date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('cr_number')}>
                                                                CHILD ROLL NUMBER {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('master_reel')}>
                                                                MASTER REEL {sortColumn === 'master_reel' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('width')}>
                                                                SIZE {sortColumn === 'width' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('release_no')}>
                                                                MO & MA NUMBER {sortColumn === 'release_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('set_no')}>
                                                                SET NUMBER {sortColumn === 'set_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('item_code')}>
                                                                QUALITY {sortColumn === 'item_code' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('gsm')}>
                                                                GSM {sortColumn === 'gsm' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('order_qty')}>
                                                                APPROX.WT (TONS) {sortColumn === 'order_qty' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('achieved_qty')}>
                                                                CONFIRAM.WT (TONS){sortColumn === 'achieved_qty' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>
                                                            <TableCell onClick={() => handleSort('status')}>
                                                                STATUS {sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                            </TableCell>

                                                            <TableCell>
                                                                <IconButton onClick={handleOpen}>
                                                                    <Searchicon style={{ fontSize: "16px" }} />
                                                                </IconButton>
                                                                <Modal
                                                                    open={open}
                                                                    onClose={handleClose}
                                                                    aria-labelledby="modal-modal-title"
                                                                    aria-describedby="modal-modal-description"
                                                                >
                                                                    <Box sx={{ position: 'absolute', top: '38.2%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: colors.primary[400], boxShadow: 29, p: 4, minWidth: 300 }}>

                                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <TextField
                                                                                label="From Date"
                                                                                name="from_date"
                                                                                type="date"
                                                                                value={filters.from_date}
                                                                                onChange={handleFilterChange}
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                margin="normal"
                                                                                sx={{ marginRight: 1 }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                            <TextField
                                                                                label="To Date"
                                                                                name="to_date"
                                                                                type="date"
                                                                                value={filters.to_date}
                                                                                onChange={handleFilterChange}
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                margin="normal"
                                                                                sx={{ marginLeft: 1 }}
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        </Box>

                                                                        <TextField
                                                                            label="Child Roll Number"
                                                                            name="cr_number"
                                                                            value={filters.cr_number}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="Master Reel (size)"
                                                                            name="master_reel"
                                                                            value={filters.master_reel}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="MO Number"
                                                                            name="release_no"
                                                                            value={filters.release_no}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />

                                                                        <TextField
                                                                            label="Quality"
                                                                            name="item_code"
                                                                            value={filters.item_code}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <TextField
                                                                            label="GSM"
                                                                            name="gsm"
                                                                            value={filters.gsm}
                                                                            onChange={handleFilterChange}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                        <Button variant="contained" color="secondary" onClick={() => { applyFilter(); handleClose(); }} style={{ marginTop: 10 }}>
                                                                            Apply Filter
                                                                        </Button>
                                                                    </Box>
                                                                </Modal>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableFilterRow
                                                            columns={columns}
                                                            filters={filters}
                                                            handleFilterChange={handleFilterChangeTable}
                                                            uniqueValues={uniqueValues}
                                                            autoCompleteColumns={autoCompleteColumns}
                                                        />
                                                    </TableHead>
                                                    <TableBody>
                                                        {/* {sortedData.map((row) => ( */}
                                                        {currentRecords.map((row, index) => (
                                                            <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                                <TableCell>{row.date}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(row.id, row.cr_number)}
                                                                    >
                                                                        {row.cr_number}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{`${row.master_reel} `}</TableCell>
                                                                <TableCell>{`${row.width} X ${row.length}`}</TableCell>
                                                                <TableCell>{`${row.release_no} / ${row.lot_no}`}</TableCell>
                                                                <TableCell sx={{ textAlign: 'right' }}>{row.set_no}</TableCell>
                                                                <TableCell>{row.item_code}</TableCell>
                                                                <TableCell sx={{ textAlign: 'right' }}>{row.gsm}</TableCell>
                                                                <TableCell sx={{ textAlign: 'right' }}>{(row.order_qty * 1000)}</TableCell>
                                                                <TableCell sx={{ textAlign: 'right' }}>{(row.achieved_qty * 1000)}</TableCell>

                                                                <TableCell sx={{ textAlign: "left", width: '120px', padding: '2px' }}>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                                                                        <Box
                                                                            sx={{
                                                                                width: 8,
                                                                                height: 8,
                                                                                borderRadius: '50%',
                                                                                backgroundColor: row.status === 'approved' ? '#42a5f5'
                                                                                    : row.status === 'wip' ? '#f57c00'
                                                                                        : row.status === 'fg' || row.status === 'converted' ? '#66bb6a'
                                                                                            : 'gray'
                                                                            }}
                                                                        />
                                                                        <Typography variant="caption" sx={{ fontSize: '11px' }}>{row.status}</Typography>
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            )}
                                            <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
                                        </TableContainer>
                                    </CustomTableContainer>
                                </ResponsiveBox>
                            </Grid>
                        </Grid>
                    </>
                )}

                {viewReelWeightment && (
                    <>


                        {viewWarehouseLocation === false && (
                            <>
                                <Header title={t('prod_menu.reelweightement')} subtitle="" callback={callback} />

                                <Dialog
                                    open={open}
                                    onClose={closepopup}
                                    fullWidth
                                    maxWidth="xs"

                                >
                                    <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                                        <QualityCheckRejectProcee rejectReelType={'CHILDROLL'} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} />
                                    </DialogContent>
                                    <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                                        <Button onClick={closepopup} variant="contained">
                                            Update
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                {/* filter part */}
                                <Card style={{ backgroundColor: "Transparent", borderRadius: "0px", height: "48px" }}>
                                    <CardContent style={{ padding: '5px 5px 5px 5px' }}>
                                        <Box display="flex" justifyContent="space-between" p={0.1}   >

                                            <FormControl fullWidth size="small">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <Typography variant="h6" fontWeight="bold"> {t('prod_reel_weightment.filter_by')} </Typography>
                                                        <FilterButtons filterData={filterData} period={period} setPeriod={setPeriod} />
                                                        <Typography variant="h6" fontWeight="bold"> {t('prod_reel_weightment.child_roll_number')}</Typography>
                                                        <Autocomplete
                                                            fullWidth
                                                            variant="standard"
                                                            value={sheeterSelectedChildRoll}
                                                            onChange={handleSelectSheeterChildRollNumber}
                                                            size="small"
                                                            style={{ width: '300px' }}
                                                            options={sheeterChildRoll || []}
                                                            getOptionLabel={(option) => `${option.child_reel_number}`}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    style={{ marginRight: "10px" }}
                                                                />
                                                            )}
                                                        />
                                                        {viewReelDetail && (
                                                            <>

                                                                {/* {hasPermission(userPermissions, "Reel Weightment", "Print") && (
                                                                    <div>
                                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />
                                                                        <Grid item md={0} ml="5px" mr="5px">
                                                                            <Tooltip title="Print child reel code">
                                                                                <IconButton onClick={() => handleButtonClick('PrintQR')}  >
                                                                                    <QrCodeRoundedIcon style={{ color: selectedButton === 'PrintQR' ? "yellow" : "#009688", fontSize: "20px" }} />
                                                                                </IconButton>
                                                                                <span style={{ fontSize: 12 }}>{t('prod_reel_weightment.btn_print_qr')}</span>
                                                                            </Tooltip>
                                                                        </Grid>

                                                                    </div>
                                                                )} */}

                                                                {hasPermission(userPermissions, "Reel Weightment", "Delete") && (
                                                                    <div>
                                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />
                                                                        <Grid item md={0} ml="5px" mr="5px">
                                                                            <Tooltip title="Reject Child Reel">
                                                                                <IconButton onClick={() => openpopup('RejectChild')}  >
                                                                                    <ThumbDownAltOutlinedIcon style={{ color: selectedButton === 'RejectChild' ? "yellow" : "#f44336", fontSize: "20px" }} />
                                                                                </IconButton>
                                                                                <span style={{ fontSize: 12 }}>Reject Child Roll</span>
                                                                            </Tooltip>
                                                                        </Grid>
                                                                    </div>
                                                                )}


                                                                {wlocationRef === 'NA' && hasPermission(userPermissions, "Reel Weightment", "Update") && (<>

                                                                    <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />
                                                                    <Grid item md={0} ml="5px" mr="5px">
                                                                        <Tooltip title="Reverse Reel weightment update">
                                                                            <IconButton onClick={() => { handleReverseReelWeightment(); }}  >
                                                                                <SettingsBackupRestoreIcon style={{ color: selectedButton === 'Reverse FG' ? "yellow" : "#69f0ae", fontSize: "20px" }} />
                                                                            </IconButton>
                                                                            <span style={{ fontSize: 12 }}>Reverse FG Status</span>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                </>)}


                                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />

                                                                {enableWarehouseOption && (
                                                                    <>
                                                                        <Grid item md={0} ml="5px" mr="5px">
                                                                            <Tooltip title="store reel in to warehouse">
                                                                                <IconButton onClick={() => setWarehouse('Warehouse')}  >
                                                                                    <WarehouseOutlinedIcon style={{ color: selectedButton === 'Warehouse' ? "yellow" : "#9575cd", fontSize: "20px" }} />
                                                                                </IconButton>
                                                                                <span style={{ fontSize: 12 }}>Store to Warehoue</span>
                                                                            </Tooltip>
                                                                        </Grid>
                                                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />
                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                    </Stack>
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Box>
                                    </CardContent>
                                </Card>



                                {/* Message box detail */}
                                <CallAlertBar parentRollMsgOpen={reelWeightementMsgOpen} setParentRollMsgOpen={setReelWeightementMsgOpen} parentRollSeverityvalue={reelWeightementSeverityvalue}
                                    setParentRollSeverityvalue={setReelWeightementSeverityvalue} parentRollAlertTitleValue={reelWeightementAlertTitleValue}
                                    setParentRollAlertTitleValue={setReelWeightementAlertTitleValue} parentRollMessageValue={reelWeightementMessageValue} setParentRollMessageValue={setReelWeightementMessageValue} />
                            </>)}

                        {/* 
                            <Box sx={{ padding: "10px" }} display="flex">
                                <Typography>Scan Reel Value</Typography>
                                <Button
                                    sx={{
                                        backgroundColor: colors.blueAccent[700],
                                        color: colors.grey[100],
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        padding: "10px 20px",
                                        marginLeft:"10px"
                                    }}
                                // onClick={}
                                >

                                    Scan QR Code
                                </Button>
                            </Box> */}

                        {/* <Box>
                                <QRScanner qrValue={scanQRValue} setQRValue={setQRValue}/>
                            </Box>

                            <Typography>{scanQRValue}</Typography> */}



                        <ResponsiveBox colors={colors} customMaxHeight={{
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '85vh', // Large devices (desktops)
                            xl: '89vh', // Extra large devices (large desktops)
                        }}>

                            {viewReelDetail && (
                                <>

                                    <Grid container  >
                                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid container spacing={1}  >

                                                <Grid mt={0} item xs={12} sm={12} md={12} lg={6} xl={5}   >

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.reel_no')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={code} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.status')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={status} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>

                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.parent_roll')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={parentRoll} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.lot_number')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <TextField value={lotNumber} fullWidth size="small" type="text" disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}></TextField>
                                                        </Grid>
                                                    </Grid>


                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.quality')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={quality} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.gsm')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={gsm} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.reel_size')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={reelSize} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.reel_length')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            {/* <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={reelLength} fullWidth size="small" type="text" ></TextField> */}
                                                            <TextField disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={roolLength} fullWidth size="small" type="text" ></TextField>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.reel_weight')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={reelWeight} fullWidth size="small" type="text" disabled></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.reel_joined')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <TextField sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }} value={reelJoined} fullWidth size="small" type="text" disabled></TextField>
                                                        </Grid>
                                                    </Grid>

                                                    {/* <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.id')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <TextField value={id} fullWidth size="small" type="text" disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}></TextField>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.lot_number')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <TextField value={lotNumber} fullWidth size="small" type="text" disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}></TextField>
                                                        </Grid>
                                                    </Grid> */}

                                                    <Grid container padding="5px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                                            <Divider />
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.shift_date_time')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <FormControl fullWidth size="small">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <Stack spacing={1}>
                                                                        <DatePicker
                                                                            value={dayjs(shiftDate)} // Ensure shiftDate is a valid Day.js object or compatible string
                                                                            onChange={(date) => setShiftDate(date)}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: "small",
                                                                                    variant: "outlined",
                                                                                    fullWidth: true, // Add fullWidth here if needed
                                                                                },
                                                                            }}
                                                                            format="DD-MMM-YYYY" // For date formatting
                                                                            minDate={dayjs().subtract(4, 'year')}
                                                                            maxDate={dayjs().add(1, 'year')}
                                                                        />
                                                                    </Stack>
                                                                </LocalizationProvider>
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.shift_code')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <FormControl fullWidth size="small">
                                                                <Autocomplete
                                                                    fullWidth
                                                                    value={winderShiftCode}
                                                                    onChange={handleWinderShiftChange}
                                                                    size="small"
                                                                    style={{ fontSize: '12px' }}
                                                                    options={shiftCodes}
                                                                    getOptionLabel={(option) => `${option.shiftcode}`}
                                                                    renderInput={(params) =>
                                                                        <TextField required
                                                                            {...params} variant="outlined" />}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.operator')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.9} xl={3.1}>
                                                            <FormControl fullWidth size="small">
                                                                <Autocomplete
                                                                    fullWidth
                                                                    value={selectedOperator}
                                                                    onChange={handleOperatorChange}
                                                                    size="small"
                                                                    style={{ fontSize: '12px' }}
                                                                    options={operator}
                                                                    getOptionLabel={(option) => `${option.operator_code}`}
                                                                    renderInput={(params) =>
                                                                        <TextField required
                                                                            {...params} variant="outlined" />}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.grade')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={3.1} xl={3.1}>
                                                            <FormControl fullWidth size="small">
                                                                <Autocomplete
                                                                    size="small"
                                                                    options={["G1", "SL", "Repulp"]}
                                                                    value={selectedGrade || ""}
                                                                    onChange={(e, value) => {
                                                                        setSelectedGrade(value); // Use the second argument to get the selected value
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant="outlined"
                                                                            sx={{
                                                                                "& .MuiInputBase-input": { padding: "4px" },
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            </FormControl>

                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.po_number')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={6} lg={6} xl={6}>
                                                            <TextField value={poNumber} fullWidth size="small" type="text" disabled sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dashed', } } }}></TextField>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.location')}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={6} lg={6} xl={6}>
                                                            <TextField value={locationRef} onChange={(e) => { setLocationRef(e.target.value) }} fullWidth size="small" type="text" sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'line', } } }}></TextField>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.remarks')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={8} xl={8}>
                                                            <Autocomplete
                                                                size="small"
                                                                fullWidth
                                                                loading={loadingRemarks}
                                                                options={remarkOptions}   // full objects from API
                                                                getOptionLabel={(option) => option?.description || ""}  // 👈 show only description
                                                                value={remarkOptions.find(opt => opt.description === remark) || null}
                                                                onChange={(e, newValue) => setRemark(newValue ? newValue.description : "")}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} label="Remarks" variant="outlined" />
                                                                )}
                                                            />

                                                        </Grid>

                                                        <Grid item xs={12} sm={11} md={3.8} lg={1} xl={1}>

                                                            <Tooltip title="Add New Remarks" arrow>
                                                                <AddCircleOutlineIcon
                                                                    color="secondary"
                                                                    sx={{ cursor: "pointer", marginLeft: 1 }}
                                                                    onClick={handleOpenAddRemark}
                                                                />
                                                            </Tooltip>
                                                        </Grid>

                                                        {openAddRemark && (
                                                            <AddRemarks open={openAddRemark} onClose={handleCloseAddRemark} moduleName={"Reel Weightment"} parentModuleName={"Production"} userPermissions={userPermissions} />
                                                        )}


                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.party_remarks')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={9.5} xl={8.7}>
                                                            <TextField value={partyRemark} onChange={(e) => { setPartyRemark(e.target.value) }} fullWidth size="small" type="text" sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'line', } } }}></TextField>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.gross_weight')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={9.5} xl={8.7}>
                                                            <TextField fullWidth size="small" value={updateReelWeight} inputProps={{ min: 0 }} autoFocus={focusWeight} onChange={updateReelWeightValue} type="number" />
                                                        </Grid>
                                                    </Grid>


                                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={11.2} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                <Typography marginTop={1} variant="h6">{reelWeightMessage}</Typography>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    {/* <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                        <Grid item xs={12} sm={12} md={1.6} lg={2.5} xl={2.5} display="flex-start" justifyContent="center">
                                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                {t('prod_reel_weightment.wlocation')}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={11} md={3.8} lg={9.5} xl={8.7}>
                                                            <TextField fullWidth size="small" value={wlocationRef} type="text" />
                                                        </Grid>
                                                    </Grid> */}

                                                    {wlocationRef !== 'NA' && (<>
                                                        <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={11.2} display="flex-start" justifyContent="center">
                                                                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                                    <Typography marginTop={1} variant="h6"> * The reel is already stored in warehouse location: {wlocationRef}, so reel weight modification is not allowed.</Typography>
                                                                </Typography>
                                                            </Grid>

                                                        </Grid>
                                                    </>)}
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "10px", marginRight: "10px" }} />

                                                {/* left side value */}
                                                <Grid mt={0} item xs={11} sm={11} md={6} lg={4.2} xl={3}>
                                                    <Box sx={{ p: 1, borderRadius: 10 }}>
                                                        <> <LabelChildRollDetails qrCodeValue={qrCodeValue} selectedProductDetails={selectedChildRollDetails} company_id={localStorage.getItem('companyid')} mode={0} modulename='Reel Weightment' />  </>
                                                    </Box>

                                                    {enableWarehouseOption === false && (
                                                        <Card sx={{ marginTop: "10px", borderRadius: "5px", backgroundColor: "transparent" }} variant="outlined"  >
                                                            <CardContent>
                                                                <div>
                                                                    <h4> <FmdGoodOutlinedIcon sx={{ fontSize: "25px", color: "#f06292", marginRight: "5px" }} />{`Reel was stored in : ${locationDetail?.length > 0 ? locationDetail[0].location_code || '' : ''}`}</h4>
                                                                </div>
                                                            </CardContent>
                                                        </Card>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            )}

                            <>
                                {code !== '' && (
                                    <>
                                        <Grid container padding="5px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                                <Divider />
                                            </Grid>
                                        </Grid>

                                        <Grid container padding="10px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                {wlocationRef === 'NA' && (<>
                                                    {hideSaveBth === false ? (
                                                        <>
                                                            {enableSaveBtn === true ? (
                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <Button variant="contained" size="small" onClick={SaveReelWeightement} label="Edit" color="secondary">{t('prod_reel_weightment.btn_save')}</Button>
                                                                </Box>
                                                            ) : (
                                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <Button variant="contained" size="small" disabled={enableSaveBtn} onClick={SaveReelWeightement} label="Save" color="secondary">{t('prod_reel_weightment.btn_save')}</Button>
                                                                </Box>
                                                            )}
                                                        </>) : (null)}
                                                </>)}

                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </>
                        </ResponsiveBox>
                    </>
                )}

            </Box>

        </>
    )
}
export default ReelWeightment;